var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send_email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36,
    height: 36,
    rx: 4,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "print_black_24dp_3_",
    "data-name": "print_black_24dp (3)",
    transform: "translate(-13 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56175",
    "data-name": "Path 56175",
    d: "M0,0H24V24H0Z",
    transform: "translate(19)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_send",
    d: "M4,4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2h8V18a2,2,0,0,1,2-2h4l.066-.008A2.784,2.784,0,0,1,22,14.08V6a2,2,0,0,0-2-2Zm.855,2.682a.839.839,0,0,1,.441.129L12,11l6.7-4.189a.848.848,0,1,1,.9,1.437L12.529,12.67a1,1,0,0,1-1.059,0L4.4,8.248a.848.848,0,0,1,.457-1.566ZM20.725,15.8A.8.8,0,0,0,20,16.6V18H15a1,1,0,0,0,0,2h5v1.4a.8.8,0,0,0,1.365.564l2.4-2.4a.8.8,0,0,0,0-1.131l-2.4-2.4A.8.8,0,0,0,20.725,15.8Z",
    transform: "translate(18 -1)",
    fill: "#374955"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send_email.8e99b6ada3dc7cb83560b053f57d1583.svg";
export { ForwardRef as ReactComponent };